export class ParentProject {
    constructor() {
        this.id = 0;
        this.des = '';
        this.status = null;
        // this.templatesRef = [];
        this.b2bHeaderC = [];
        this.b2bHeaderT = [];

        // Shop
        this.shopid = null;
        this.shopdes = null;

        // Seller
        this.sellerid = null;
        this.sellerdes = null;
        this.sellermail = null;
        this.sellertel = null;
        this.sellerlevel = null;

        // Templates
        this.currTemp = 0;

    }

    getJson() {
        return JSON.parse(JSON.stringify(this));
    }

    forceValidTemp() {
        if (this.currTemp < 1 && this.b2bHeaderT.length > 0)
            this.currentrow = this.b2bHeaderT[0].NTemplate;
        else if (this.b2bHeaderT.length < 1)
            console.warn('No valid templates');
    }

    getActiveTemp() {
        this.forceValidTemp();

        let temp = this.b2bHeaderT.find(t => {
            return t.NTemplate === this.currTemp;
        });

        return temp;
    }

    setActiveTempById(id) {
        let temp = this.b2bHeaderT.find(t => {
            return t.NTemplate === id;
        });

        if (temp === null) {
            this.currTemp = 0;
        }
        // throw new Error('Template with id '+ id +' is missing');

        else {
            this.currTemp = id;
        }
    }
}

export class B2bHeaderT {
    constructor() {
        this.NTemplate = 0;
        this.IdParent = 0;
        this.frontendFeatureLocked = 0;
        this.comments = "";
        this.qty = 1;
        this.price = 0;
        this.isLocked = false;
        this.specifyVariantCost = 0
    }
}

export class B2bHeaderC {
    constructor() {
        this.NChild = 0;
        this.NTemplate = 0;
        this.IdParent = 0;
        this.des = "";
        this.status = "";
        this.changetype = "";
        this.seller = 0;
        this.customer = "";
        this.deliverybatch = 0;
        this.isDetached = false
    }
}



// WEBPACK FOOTER //
// ./src/custom/epoq/_modules/ParentProject.js